import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

let abortControllerFetchOrders = null;

export const fetchOrdersAdmin = createAsyncThunk(
  'get/rooms/v3/design/order/admin/list',
  async (
    { offset, limit, fulfillment_status, product_name, amount, kw },
    { dispatch }
  ) => {
    try {
      if (abortControllerFetchOrders) {
        abortControllerFetchOrders.abort();
      }
      abortControllerFetchOrders = new AbortController();
      const res = await callApi({
        endpoint: 'rooms/v3/design/order/admin/list/',
        method: 'get',
        params: {
          offset,
          limit,
          fulfillment_status,
          product_name,
          amount,
          kw,
        },
        signal: abortControllerFetchOrders.signal,
      });

      const response = res.data;
      if (response.success) {
        return { data: response?.result?.data, total: response?.count ?? 0 };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

export const fetchOrderAdmin = createAsyncThunk(
  'get/rooms/v3/design/order/admin/{id}/',
  async ({ id }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'rooms/v3/design/order/admin/' + id + '/',
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        return { data: response?.result?.data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

export const updateOrderAdmin = createAsyncThunk(
  'put/rooms/v3/design/order/admin/{id}/update/',
  async (data, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'rooms/v3/design/order/admin/' + data.id + '/update/',
        method: 'put',
        data: data,
      });

      const response = res.data;
      if (response.success) {
        return { data: response?.result?.data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

export const fetchStatMonthly = createAsyncThunk(
  'put/rooms/v3/design/order/admin/stat/monthly',
  async (_, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'rooms/v3/design/order/admin/stat/monthly',
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        return { data: response?.result?.data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

export const remindPayment = createAsyncThunk(
  'post/rooms/v3/design/order/admin/remind_payment/{id}/',
  async ({ id }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'rooms/v3/design/order/admin/remind_payment/' + id + '/',
        method: 'post',
      });

      const response = res.data;
      if (response.success) {
        return { data: response?.result?.data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

export const createRefund = createAsyncThunk(
  'post/rooms/v3/design/order/create_refund',
  async ({ order_code }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: `rooms/v3/design/order/create_refund`,
        method: 'post',
        data: { order_code },
      });

      const response = res.data;
      if (response.success) {
        return { data: response?.result?.data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);

export const confirmRefund = createAsyncThunk(
  'put/rooms/v3/design/order/admin_confirm_refund/{refund_id}',
  async ({ refund_id }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: `rooms/v3/design/order/admin_confirm_refund/` + refund_id,
        method: 'put',
      });

      const response = res.data;
      if (response.success) {
        return { data: response?.result?.data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
